<script setup>
import authV2ForgotPasswordIllustrationBorderedDark from "@images/pages/auth-v2-forgot-password-illustration-dark-border.png";
import authV2ForgotPasswordIllustrationDark from "@images/pages/auth-v2-forgot-password-illustration-dark.png";
import authV2ForgotPasswordIllustrationBorderedLight from "@images/pages/auth-v2-forgot-password-illustration-light-border.png";
import authV2ForgotPasswordIllustrationLight from "@images/pages/auth-v2-forgot-password-illustration-light.png";
import tree1 from "@images/misc/tree1.png";
import authV2MaskDark from "@images/pages/mask-v2-dark.png";
import authV2MaskLight from "@images/pages/mask-v2-light.png";
import { VNodeRenderer } from "@layouts/components/VNodeRenderer";
import { themeConfig } from "@themeConfig";
import { $api } from "@/utils/api";
import { useRoute, useRouter } from "vue-router";
import logo from "@/assets/images/logo.png";

const authThemeImg = useGenerateImageVariant(
    authV2ForgotPasswordIllustrationLight,
    authV2ForgotPasswordIllustrationDark,
    authV2ForgotPasswordIllustrationBorderedLight,
    authV2ForgotPasswordIllustrationBorderedDark,
    true
);
const authThemeMask = useGenerateImageVariant(authV2MaskLight, authV2MaskDark);
const email = ref("");
const message = ref("");
const isSnackbarTopEndVisible = ref(false);
const refVForm = ref();
const route = useRoute();
const router = useRouter();

definePage({
    meta: {
        layout: "blank",
        unauthenticatedOnly: true,
    },
});

const forgotPassword = async () => {
    try {
        console.log("aqui");

        const res = await $api("/forgot-password", {
            method: "POST",
            body: { email: email.value },
        });
        await nextTick(() => {
            router.replace(route.query.to ? String(route.query.to) : "/");
        });
        console.log("res", res);
    } catch (err) {
        console.log("err", err.response);
        isSnackbarTopEndVisible.value = true;
        message.value = err.response._data.message;
    }
};

const onSubmit = () => {
    refVForm.value?.validate().then(({ valid: isValid }) => {
        if (isValid) forgotPassword();
    });
};
</script>

<template>
    <!-- <RouterLink to="/">
        <div class="auth-logo d-flex align-center gap-x-3">
            <VNodeRenderer :nodes="themeConfig.app.logo" />
            <h1 class="auth-title">
                {{ themeConfig.app.title }}
            </h1>
        </div>
    </RouterLink> -->

    <VRow class="auth-wrapper" no-gutters>
        <VCol md="8" class="d-none d-md-flex position-relative">
            <div class="d-flex align-center justify-center w-100 h-100 pe-0">
                <VImg max-width="600" :src="logo" class="auth-illustration" />
            </div>

            <img class="auth-footer-mask" height="360" :src="authThemeMask" />

            <!-- <img
        :src="tree1"
        alt="tree image"
        height="140"
        class="auth-footer-tree"
      > -->
        </VCol>

        <VCol
            cols="12"
            md="4"
            class="auth-card-v2 d-flex align-center justify-center"
            style="background-color: rgb(var(--v-theme-surface))"
        >
            <VCard flat :max-width="500" class="mt-12 mt-sm-0 pa-4">
                <VCardText>
                    <h4 class="text-h4 mb-1">¿Olvidó su contraseña? 🔒</h4>
                    <p class="mb-0">
                        Ingrese su email y le enviaremos las instrucciones para
                        restablecer su contraseña
                    </p>
                </VCardText>

                <VCardText>
                    <VForm ref="refVForm" @submit.prevent="onSubmit">
                        <VRow>
                            <!-- email -->
                            <VCol cols="12">
                                <VTextField
                                    v-model="email"
                                    autofocus
                                    label="Email"
                                    placeholder="johndoe@email.com"
                                    type="email"
                                />
                            </VCol>

                            <!-- Reset link -->
                            <VCol cols="12">
                                <VBtn block type="submit"> Recuperar </VBtn>
                            </VCol>

                            <!-- back to login -->
                            <VCol cols="12">
                                <RouterLink
                                    class="d-flex align-center justify-center"
                                    :to="{ name: 'login' }"
                                >
                                    <VIcon
                                        icon="ri-arrow-left-s-line"
                                        class="flip-in-rtl"
                                    />
                                    <span>Volver al login</span>
                                </RouterLink>
                            </VCol>
                        </VRow>
                    </VForm>
                </VCardText>
            </VCard>
        </VCol>
    </VRow>

    <VSnackbar v-model="isSnackbarTopEndVisible" location="top end">
        {{ message }}
    </VSnackbar>
</template>

<style lang="scss">
@use "@core/scss/template/pages/page-auth.scss";
</style>
